export default __webpack_public_path__ + "static/media/gift.78dd8f12.png";